"use client";
import React from "react";
import TopBar from "../components/common/TopBar";
import RegistrationForm from "./../components/RegistrationForm";

const RegistrationPage = () => {
  return (
    <main className="flex flex-col items-center w-full min-h-screen bg-white">
      <TopBar />
      <RegistrationForm />
    </main>
  );
};

export default RegistrationPage;
